'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderChange = void 0;
const $ = require("jquery");
class HeaderChange {
    constructor() {
        //loadとscrollのイベント時
        $(window).on('load scroll', (e) => {
            //scrollした高さを取得
            const position = $(e.currentTarget).scrollTop();
            //スクロール位置が100以上の時、data-is-scrollをtrueに
            if (position > 10) {
                $('.bulletChangeHeader').attr('data-is-scroll', 'true');
                //99以下の時は、data-is-scrollをfalseに
            }
            else {
                $('.bulletChangeHeader').attr('data-is-scroll', 'false');
            }
        });
    }
}
exports.HeaderChange = HeaderChange;
exports.default = HeaderChange;
